import AddressIntl, { DEFAULT_VALUE } from './AddressIntl';

export default AddressIntl;
export { DEFAULT_VALUE };